import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'
import size from '../../../../utills/size'

export const sectionContainerStyles = {
    padding: `0 ${pxToRem(7)}`,
    [`@media (min-width: ${size.md})`]: {
        padding: `0 ${pxToRem(21)}`
    },
    h2: {
        textAlign: 'center',
        fontSize: pxToRem(18),
        lineHeight: pxToRem(21.6),
        marginTop: pxToRem(40),
        marginBottom: pxToRem(50),
        textTransform: 'uppercase',
        fontFamily: fonts.primary,
        color: 'cav_light_black',
        fontWeight: 700,
        letterSpacing: pxToRem(4.68),
        [`@media (min-width: ${size.md})`]: {
            color: 'cav_light_black',
            fontSize: pxToRem(40),
            lineHeight: pxToRem(48),
            marginBottom: pxToRem(30),
            letterSpacing: pxToRem(10.5)
        }
    }
}

export const linkTextStyles = {
    p: {
        fontSize: pxToRem(14),
        fontWeight: 700,
        height: pxToRem(18),
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(18),
        marginTop: pxToRem(30),
        marginBottom: pxToRem(40),
        fontFamily: fonts.primary,
        [`@media (min-width: ${size.md})`]: {
            marginBottom: 0
        }
    },
    _hover: {
        color: 'cav_red',
        textDecoration: 'none'
    }
}

export const infoContainerstyles = {
    backgroundColor: 'cav_dark_gray_info',
    padding: pxToRem(20),
    fontSize: pxToRem(12),
    lineHeight: pxToRem(16),
    fontFamily: fonts.primary,
    color: 'cav_light_black',
    h1: {
        fontSize: pxToRem(24),
        fontWeight: 400,
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(30),
        textTransform: 'capitalize',
        margin: `${pxToRem(10)} 0`,
        [`@media (min-width: ${size.md})`]: {
            fontSize: pxToRem(21),
            lineHeight: pxToRem(16),
            marginBottom: pxToRem(14)
        }
    },
    h2: {
        fontSize: pxToRem(28),
        fontWeight: 700,
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(30),
        margin: `${pxToRem(23)} 0`,
        [`@media (min-width: ${size.md})`]: {
            fontSize: pxToRem(15.6),
            lineHeight: pxToRem(16),
            margin: `${pxToRem(13)} 0`
        }
    },
    h3: {
        fontSize: pxToRem(13.8),
        textTransform: 'capitalize',
        fontWeight: 700,
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(16),
        margin: `${pxToRem(13)} 0`
    },
    p: {
        fontSize: pxToRem(12),
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(16),
        margin: `${pxToRem(12)} 0`
    },
    ul: {
        paddingLeft: 0
    }
}

export const contentContainerStyles = {
    '#category-landing-contentMiddle': {
        h2: {
            textAlign: 'center',
            fontSize: pxToRem(18),
            lineHeight: pxToRem(21.6),
            marginTop: pxToRem(40),
            marginBottom: pxToRem(50),
            textTransform: 'uppercase',
            fontFamily: fonts.primary,
            color: 'cav_light_black',
            fontWeight: 700,
            letterSpacing: pxToRem(4.68),
            [`@media (min-width: ${size.md})`]: {
                fontSize: pxToRem(40),
                lineHeight: pxToRem(48),
                marginBottom: pxToRem(30),
                letterSpacing: pxToRem(10.5)
            }
        },

        ul: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: pxToRem(10),
            paddingLeft: pxToRem(16),

            li: {
                listStyle: 'none',
                textAlign: 'center',
                width: '46%',
                boxSizing: 'border-box',
                [`@media (min-width: ${size.md})`]: {
                    width: '23%'
                }
            },

            [`@media (min-width: ${size.md})`]: {
                gap: pxToRem(25)
            }
        },

        h3: {
            fontSize: pxToRem(14),
            fontWeight: 700,
            height: pxToRem(18),
            letterSpacing: pxToRem(1),
            lineHeight: pxToRem(18),
            marginTop: pxToRem(30),
            marginBottom: pxToRem(40),
            fontFamily: fonts.primary,
            textTransform: 'capitalize',

            [`@media (min-width: ${size.md})`]: {
                marginBottom: 0
            },

            a: {
                color: 'black',
                _hover: {
                    color: 'cav_red',
                    textDecoration: 'none'
                }
            }
        }
    }
}
